import bus from "eventbusjs";

export const NotificationService = (text, ...args) => {
  bus.dispatch("notification", this, {
    text,
    ...args,
  });
};
